import React, { useMemo } from 'react'
import Alert from 'react-bootstrap/Alert'
import { useSignup } from './Signup.hooks'

const SuccessView = () => {
  const { course } = useSignup()

  const courseTypeTextPart = useMemo(() => {
    if(course.type.toLowerCase() === 'education') {
      return 'zur Ausbildung'
    }
    if(course.type.toLowerCase() === 'journey') {
      return 'zur Reise'
    }
    return 'zum Seminar'
  }, [course])

  return (
    <>
      <Alert variant="success" className="mt-4">
        Vielen Dank für deine Anmeldung{' '}
        {courseTypeTextPart}. Du
        erhältst automatisch eine Eingangsbestätigung von uns.
      </Alert>
    </>
  )
}

export default SuccessView
